/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FeedbackFormQuestion_question$ref: FragmentReference;
declare export opaque type FeedbackFormQuestion_question$fragmentType: FeedbackFormQuestion_question$ref;
export type FeedbackFormQuestion_question = {|
  +id: string,
  +title: string,
  +description: ?string,
  +$refType: FeedbackFormQuestion_question$ref,
|};
export type FeedbackFormQuestion_question$data = FeedbackFormQuestion_question;
export type FeedbackFormQuestion_question$key = {
  +$data?: FeedbackFormQuestion_question$data,
  +$fragmentRefs: FeedbackFormQuestion_question$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackFormQuestion_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "ReviewFormQuestionNode"
};
// prettier-ignore
(node/*: any*/).hash = 'ca3310e3b07740e77242cff3b928f249';

module.exports = node;
